/**
 * Lecture d'un resultat de test SpinTouch et report sur les champs du
 * formulaire d'analyse.
 *
 * Format decrit par la doc WaterLink Connect v2 API 1.7 : un tableau Results
 * dont chaque entree porte un FactorCode (enum TestFactor), une Value, des
 * Units et un State. La doc precise que c'est le FactorCode qui doit servir a
 * remplir un formulaire, le Name etant reserve a l'affichage.
 */

// FactorCode -> champ du formulaire, avec les mots-cles de repli quand
// l'appareil ne categorise pas ses mesures (cas signale par la doc).
const CORRESPONDANCES = [
  { champ: 'ValeurPH',          code: 8,  motsCles: ['ph'] },
  { champ: 'ValeurChloreLibre', code: 2,  motsCles: ['chlore libre', 'free chlorine', 'free cl'] },
  { champ: 'ValeurBrome',       code: 5,  motsCles: ['brome', 'bromine'] },
  { champ: 'ValeurTAC',         code: 9,  motsCles: ['alcal', 'alkal'] },
  { champ: 'ValeurTH',          code: 10, motsCles: ['duret', 'hardness'] },
  { champ: 'ValeurStabilisant', code: 12, motsCles: ['stabil'] },
  { champ: 'ValeurPhosphate',   code: 18, motsCles: ['phosph'] },
  // L'appareil rend le sel en ppm, le formulaire le stocke en g/L.
  { champ: 'ValeurTauxSel',     code: 19, motsCles: ['sel', 'salt'], convertir: (v) => v / 1000 }
];

const enNombre = (valeur) => {
  if (typeof valeur === 'number') {
    return isNaN(valeur) ? undefined : valeur;
  }
  if (typeof valeur === 'string') {
    const nombre = parseFloat(valeur.replace(',', '.'));
    return isNaN(nombre) ? undefined : nombre;
  }
  return undefined;
};

const valeurDe = (mesure) => enNombre(
  mesure.Value ?? mesure.value ?? mesure.Result ?? mesure.result
);

/**
 * Mesures du resultat, indexees par champ de formulaire. Les champs que le
 * disque n'a pas mesures sont absents de l'objet retourne.
 */
export function champsFormulaire(result) {
  const mesures = result && Array.isArray(result.Results) ? result.Results : [];

  return CORRESPONDANCES.reduce((champs, { champ, code, motsCles, convertir }) => {
    const parCode = mesures.find(m => m && (m.FactorCode === code || m.factorCode === code));
    const parNom = mesures.find(m => m && typeof m.Name === 'string'
      && motsCles.some(mot => m.Name.toLowerCase().includes(mot)));

    const valeur = valeurDe(parCode || parNom || {});
    if (typeof valeur === 'number') {
      champs[champ] = convertir ? convertir(valeur) : valeur;
    }
    return champs;
  }, {});
}
